import { Dispatch, SetStateAction } from "react";

import { TableColumn } from "@/components/Table/Table";
import { SortParams } from "@/types/types";

import {
	renderOrgSelectColumn,
	renderOrgLeadScoringColumn,
	renderOrgNameColumn,
	renderOrgCountryColumn,
	renderOrgIndustryColumn,
	renderOrgEmployeesColumn,
	renderOrgFoundedYearColumn,
	renderOrgCompanyCategoryColumn,
	renderOrgListsColumn,
	renderOrgCityColumn,
	renderOrgStateColumn,
	renderOrgProfileTrackerColumn,
} from "../../../Contacts/utils/allColumns";
import {
	renderCompetitorAddedByColumn,
	renderCompetitorDetectedAtColumn,
	renderCompetitorDetectedByColumn,
	renderOrgUnflagCompetitorColumn,
} from "../../utils/competitorColumns";

export interface CompetitorsTableColumnsProps {
	handleCopyClick: (value: string) => void;
	ts: (key: string) => string;
	sortingInbox: SortParams;
	setShowEdit: (val: { id: number; name: string }) => void;
	showEdit: { id: number; name: string } | undefined;
	setShowAll: Dispatch<SetStateAction<boolean>>;
	toggleSelectAll: () => void;
	selectAll: boolean;
	selectedItems: number[];
	handleSelectItem: (id: number) => void;
	onAddToTracker: (organizationId: number) => void;
	onUnflagCompetitor: (organizationId: number, companyName?: string) => void;
}

export const CompetitorsTableColumns = ({
	handleCopyClick,
	ts,
	sortingInbox,
	setShowEdit,
	showEdit,
	setShowAll,
	toggleSelectAll,
	selectAll,
	selectedItems,
	handleSelectItem,
	onAddToTracker,
	onUnflagCompetitor,
}: CompetitorsTableColumnsProps): TableColumn[] => {
	return [
		renderOrgSelectColumn(setShowAll, toggleSelectAll, selectAll, selectedItems, handleSelectItem),
		// Scoring badge at the very left like every other lead table (UnassignedTable,
		// CompaniesTableColumns), then company, the verdict pill and who/when. No reason
		// column — the DQ badge's hover already shows the verdict reasoning
		// (PREC-3781 review feedback).
		renderOrgLeadScoringColumn(ts, sortingInbox),
		renderOrgNameColumn(ts, handleCopyClick, sortingInbox, setShowEdit, showEdit),
		renderOrgUnflagCompetitorColumn(ts, onUnflagCompetitor),
		renderCompetitorDetectedByColumn(ts),
		renderCompetitorAddedByColumn(ts),
		renderCompetitorDetectedAtColumn(ts),
		renderOrgProfileTrackerColumn(ts, onAddToTracker),
		renderOrgCountryColumn(ts, handleCopyClick, sortingInbox),
		renderOrgIndustryColumn(ts, handleCopyClick, sortingInbox),
		renderOrgEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderOrgFoundedYearColumn(ts, sortingInbox),
		renderOrgCompanyCategoryColumn(ts, sortingInbox),
		renderOrgListsColumn(ts),
		renderOrgCityColumn(ts, handleCopyClick, sortingInbox),
		renderOrgStateColumn(ts, handleCopyClick, sortingInbox),
	];
};
